export default __webpack_public_path__ + "static/media/eb-blk-banner-3.5aae8f92.jpg";